export default __webpack_public_path__ + "static/media/Flag_of_Saudi_Arabia.svg.622f871b.png";